import React from "react";

function AdminFooter() {
    return (
        <>
            <footer className="level section has-background-light is-full-width">
                <div className="level-left">
                    <div className="level-item">
                        <p className="is-size-6 has-text-grey">
                            Copyright © {new Date().getFullYear()} CSEA NIT
                            Andhra Pradesh. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default AdminFooter;
